// config/projectApiEndpoints.js
// Import centralized API configuration
import { BASE_API, API_VERSION, API_BASE_URL } from '../../../shared/config/apiConfig';

// Re-export for backward compatibility
export { BASE_API, API_VERSION };

export const PROJECT_API_BASE = API_BASE_URL;

// Project endpoint
export const PROJECT_ENDPOINTS = {
  create: `${PROJECT_API_BASE}/projects/create`,
  getAll: `${PROJECT_API_BASE}/projects/folders`,
  updateProject:(projectId) =>  `${PROJECT_API_BASE}/projects/${projectId}/update`,
  deleteProject: (projectId) => `${PROJECT_API_BASE}/projects/${projectId}`,
  createFolder: (projectId, path) => `${PROJECT_API_BASE}/projects/${projectId}/folders?path=${encodeURIComponent(path)}`,
  deleteFolder: (projectId, path) => `${PROJECT_API_BASE}/projects/${projectId}/folders?path=${encodeURIComponent(path)}`,
  updateFile: (projectId) => `${PROJECT_API_BASE}/projects/${projectId}/folders/files`,
};

// File endpoints
export const FILE_ENDPOINTS = {
  getFiles: (projectId, path) => `${PROJECT_API_BASE}/projects/${projectId}/folders/files?path=${encodeURIComponent(path || '')}`,
  createFile: (projectId, folderPath) => `${PROJECT_API_BASE}/projects/${projectId}/folders/files?folderPath=${encodeURIComponent(folderPath || '')}`,
  updateFile: (projectId) => `${PROJECT_API_BASE}/projects/${projectId}/folders/files`,
  deleteFile: (projectId, fileName, folderPath) => `${PROJECT_API_BASE}/projects/${projectId}/folders/files?fileName=${fileName}&folderPath=${folderPath}`,
  downloadFile: (projectId, s3FolderPath) => `${PROJECT_API_BASE}/projects/${projectId}/folders/file/download?s3FolderPath=${encodeURIComponent(s3FolderPath || '')}`,
  getFileContent: (projectId, fileName, folderPath) => `${PROJECT_API_BASE}/projects/${projectId}/folders/files/content?fileName=${encodeURIComponent(fileName || '')}&folderPath=${encodeURIComponent(folderPath || '')}`,
  listByPrefix: (projectId, prefix) => `${PROJECT_API_BASE}/files?prefix=${encodeURIComponent(prefix || '')}`,
};

// Test execution endpoints
export const TEST_ENDPOINTS = {
  createRun: (projectId, tenantId) => `${PROJECT_API_BASE}/projects/${projectId}/null/runs?tenantId=${tenantId}`,
  runFeature: (projectId) => `${PROJECT_API_BASE}/projects/${projectId}/run-feature`,
  getRun:(projectId, runnableId, runId, tenantId) => `${PROJECT_API_BASE}/projects/${projectId}/${runnableId}/runs/${runId}?tenantId=${tenantId}`,
  getRecentRunsByProject: (projectId, tenantId, limit, fromDate, toDate) => {
    let url = `${PROJECT_API_BASE}/projects/${projectId}/runs/recent?tenantId=${tenantId}&limit=${limit}`;
    if (fromDate) url += `&fromDate=${encodeURIComponent(fromDate)}`;
    if (toDate) url += `&toDate=${encodeURIComponent(toDate)}`;
    return url;
  },
  getRunsByRunnable:(projectId, tenantId, runnableId) => `${PROJECT_API_BASE}/projects/${projectId}/${runnableId}/runs?tenantId=${tenantId}`,
  getLatestRunByRunnable: (projectId, runnableId, tenantId) => `${PROJECT_API_BASE}/projects/${projectId}/${runnableId}/runs/latest?tenantId=${tenantId}`,
};

// X-Ray endpoints
export const XRAY_ENDPOINTS = {
  UploadFeatureFile: `${PROJECT_API_BASE}/xray/import/feature`,
  GetTestCases: (projectId, suiteName, tenantId) => `${PROJECT_API_BASE}/xray/${projectId}/suites/${suiteName}/testcases?tenantId=${tenantId}`,
  UpdateTestCase: `${PROJECT_API_BASE}/xray/execution/update`
}

// Presigned S3 URL endpoints — bypasses Lambda for file transfers > 6 MB
export const PRESIGNED_ENDPOINTS = {
  presignedUpload: (s3Path) => `${PROJECT_API_BASE}/files/presigned-upload?s3Path=${encodeURIComponent(s3Path)}`,
  presignedDownload: (s3Path) => `${PROJECT_API_BASE}/files/presigned-download?s3Path=${encodeURIComponent(s3Path)}`,
};

// Trash / Soft-delete endpoints
export const TRASH_ENDPOINTS = {
  deleteFile: (projectId) => `${PROJECT_API_BASE}/projects/${projectId}/folders/files`,
  deleteFolder: (projectId) => `${PROJECT_API_BASE}/projects/${projectId}/folders`,
  listTrash: (projectId) => `${PROJECT_API_BASE}/projects/${projectId}/files/trash`,
  restoreFile: (projectId) => `${PROJECT_API_BASE}/projects/${projectId}/files/restore`,
  restoreFolder: (projectId) => `${PROJECT_API_BASE}/projects/${projectId}/folders/restore`,
};

// Keep for backward compatibility
export const createProject = PROJECT_ENDPOINTS.create;
export const getAllProject = PROJECT_ENDPOINTS.getAll;
export const createFolder = PROJECT_ENDPOINTS.createFolder;
export const deleteFolder = PROJECT_ENDPOINTS.deleteFolder;
export const getAllFiles = FILE_ENDPOINTS.getFiles;
export const createFileInFolder = FILE_ENDPOINTS.createFile;
export const createRunEndpoint = TEST_ENDPOINTS.createRun;
export const updateFile = PROJECT_ENDPOINTS.updateFile;